import { Button } from 'blaze-components/WriterTopBar/Button'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { Approval } from 'blaze-ui/icons'
import { Button as MobileButton } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const FinishReviewButton = observer(() => {
  const { designStore } = useRootStore()
  const { isMobile } = useResponsiveDesign()
  const ButtonComponent = isMobile ? MobileButton : Button

  const handlePress = () => {
    designStore?.toggleReviewLater(false)
  }

  return (
    <ButtonComponent icon={Approval} onPress={handlePress} aria-label="Finish Review">
      Finish Review
    </ButtonComponent>
  )
})
